import React, { useEffect, useState } from "react";
import api from "@/lib/api";

const Group = ({ title, items, testid }) => (
  <div>
    <p className="mb-3 text-xs font-semibold uppercase tracking-[0.16em] text-slate-500">{title}</p>
    <ul className="flex flex-wrap gap-x-5 gap-y-2" data-testid={testid}>
      {items.map((l) => (
        <li key={l.href}>
          <a href={l.href} className="text-sm text-slate-400 transition-colors hover:text-white">
            {l.label}
          </a>
        </li>
      ))}
    </ul>
  </div>
);

export const ExpoLinks = () => {
  const [links, setLinks] = useState(null);

  useEffect(() => {
    api.get("/seo/hub-links").then((r) => setLinks(r.data)).catch(() => {});
  }, []);

  if (!links) return null;
  return (
    <div data-testid="expo-hub-links" className="mx-auto grid max-w-7xl gap-8 px-5 pb-10 sm:px-8 md:grid-cols-2">
      {links.guides?.length > 0 && (
        <div className="md:col-span-2">
          <Group title="Expo guides" items={links.guides} testid="expo-links-guides" />
        </div>
      )}
      <Group title="Franchise expos by country" items={links.countries} testid="expo-links-countries" />
      <Group title="Franchise shows by category" items={links.categories} testid="expo-links-categories" />
      <a href="/api/franchise-expos" data-testid="expo-calendar-link" className="text-sm font-semibold text-blue-400 hover:text-blue-300">
        Full franchise expo calendar →
      </a>
    </div>
  );
};
